export default __webpack_public_path__ + "static/media/Sector  Active.a275d879.svg";